import * as integrationService from './service';

const log = require("loglevel").getLogger("IntegrationActions");
log.setLevel("error");

export const getConnectUrl = ({ vendor, redirectUri }, callback) => {
  return async (dispatch) => {
    log.debug("IntegrationActions -> getConnectUrl -> Enter");

    const result = await integrationService.getConnectUrl({ vendor, redirectUri });
    callback?.(result);
  }
};


export const getMyconnection = (callback) => {
  return async (dispatch) => {
    log.debug("IntegrationActions -> getMyconnection -> Enter");

    const result = await integrationService.getMyconnection();
    callback?.(result);
  }
};

export const disconnectMyconnection = (callback) => {
  return async (dispatch) => {
    log.debug("IntegrationActions -> disconnectMyconnection -> Enter");

    const result = await integrationService.disconnectMyconnection();
    callback?.(result);
  }
};

export const connectToAce = ({
	connectionId,
	vendor,
	credential,
}, callback) => {
  return async (dispatch) => {
    log.debug("IntegrationActions -> connectToAce -> Enter");

    const result = await integrationService.connectToAce({ connectionId, vendor, credential });
    callback?.(result);
  }
};

export const getCRMProperties = ({ vendor, objectType }, callback) => {
  return async (dispatch) => {
    log.debug("IntegrationActions -> getCRMProperties -> Enter");

    const result = await integrationService.getCRMProperties({ vendor, objectType });
    callback?.(result);
  };
};

export const saveFieldMappings = ({ vendor, body }, callback) => {
  return async (dispatch) => {
    log.debug("IntegrationActions -> saveFieldMappings -> Enter");

    const result = await integrationService.saveFieldMappings({ vendor, body });
    callback?.(result);
  }
};

export const getFieldMappingsList = ({ vendor, crm_id }, callback) => {
  return async (dispatch) => {
    log.debug("IntegrationActions -> getFieldMappingsList -> Enter");

    const result = await integrationService.getFieldMappingsList({ vendor, crm_id });
    callback?.(result);
  }
};

export const getFieldMappingDetail = ({ id }, callback) => {
  return async (dispatch) => {
    log.debug("IntegrationActions -> getFieldMappingDetail -> Enter");

    const result = await integrationService.getFieldMappingDetail({ id });
    callback?.(result);
  }
};

export const updateFieldMappings = ({ id, body }, callback) => {
  return async (dispatch) => {
    log.debug("IntegrationActions -> updateFieldMappings -> Enter");

    const result = await integrationService.updateFieldMappings({ id, body });
    callback?.(result);
  }
};

export const deleteFieldMapping = ({ id }, callback) => {
  return async (dispatch) => {
    log.debug("IntegrationActions -> deleteFieldMapping -> Enter");

    const result = await integrationService.deleteFieldMapping({ id });
    callback?.(result);
  }
};

export const makeDefaultFieldMapping = ({ id }, callback) => {
  return async (dispatch) => {
    log.debug("IntegrationActions -> makeDefaultFieldMapping -> Enter");

    const result = await integrationService.makeDefaultFieldMapping({ id });
    callback?.(result);
  }
};

export const duplicateFieldMapping = ({ id, name }, callback) => {
  return async (dispatch) => {
    log.debug("IntegrationActions -> duplicateFieldMapping -> Enter");

    const result = await integrationService.duplicateFieldMapping({ id, name });
    callback?.(result);
  }
};

export const getSolutions = ({ vendor }, callback) => {
  return async (dispatch) => {
    log.debug("IntegrationActions -> getSolutions -> Enter");

    const result = await integrationService.getSolutions({ vendor });
    callback?.(result);
  }
};
